import { gql } from "@apollo/client";

const SAVE_VISITA_TELE_ENFERMERIA_AP = gql`
    mutation saveVisitaTeleEnfermeriaAP($input: AddVisitaTeleEnfermeriaAPInput!){
        saveVisitaTeleEnfermeriaAP(input: $input) {
            idTeleEnfermeriaAP
            idVisita
        }
    }
`;

export default SAVE_VISITA_TELE_ENFERMERIA_AP;

export const adaptAddVisitaTeleEnfermeriaAPInput = (data) => ({
  idTeleEnfermeriaAP: data?.idTeleEnfermeriaAP,
  estaPermeable: !!data?.permeable,
  fijacionDesc: data?.fijacion,
  seDesplazo: !!data?.desplazo,
  accionSiDesplazo: data?.accionDesplazo,
  frecuenciaCuracion: data?.frecuenciaCuracion,
  formaCuracion: data?.formaCuracion,
  fechaUltimaCuracion: data?.fechaUltimaCuracion,
  quienLoHizo: data?.quienCuro,
  cateterConBionector: !!data?.bionector,
  granulomaSangrado: !!data?.granulomasSangrado,
  eritemas: !!data?.eritemas,
  supuracion: !!data?.supuracion,
  dolor: !!data?.dolor,
  notaAlteracion: data?.alteracionLlamativa,
  sitioSalidaEstado: data?.sitioSalida,
  cadaCuantoCambia: data?.cadaCuantoCambia,
  comoDesinfecta: data?.desinfeccion,
  parche: data?.parche,
  idCumplimientoIndicacion: data?.idCumplimientoIndicacion,
  idBombaInfusion: data?.idBombaInfusionTelemedicina,
  idInsumoCapacitacion: data?.idInsumoCapacitacion,
  idParametrosControlClinico: data?.idParametrosControlClinico,
  idVisita: data?.idVisita
});